import { useTranslations } from '@vocab/react';
import { Box, Heading, Text } from 'braid-design-system';

import { convertSvgToBase64 } from 'src/core/utils/fileUtil';
import emptyState from 'src/images/empty-state.svg';

import translations from './.vocab';

export default () => {
  const { t } = useTranslations(translations);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      gap="xlarge"
      justifyContent="center"
      paddingY="xlarge"
    >
      <img src={convertSvgToBase64(emptyState)} />
      <Heading level="3" weight="regular">
        {t('my-group-empty-state-title')}
      </Heading>
      <Box style={{ maxWidth: '400px' }}>
        <Text weight="regular">{t('my-group-empty-state-description')}</Text>
      </Box>
    </Box>
  );
};
